import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import {
  QuotedToolTip,
  actionHeaders,
  currentQuoteKeys,
  headers,
  quoteHeaders,
  statusColors,
  oppurtunityHeaders,
  oppurtunityHeader,
  totalHeader,
  totalHeaders,
  ProductHeaders,
  ProductHeader,
} from "./Data";
import {
  CompareQuotesTableWrap,
  DropdownWrap,
  TableBox,
} from "./CompareQuoteStyled";
import Banner from "../utilities/Banner/Banner";
import { Constants, DIALOGTYPE } from "./Content";
import { HomePageWrapper } from "../Dashboard/Home/HomePageStyled";
import {
  getAllBundlesByUserAndOpportunityId,
  getAllQuotesByQuoteIdsForVisualization,
  getOpportunityByUser,
  getQuotesForBundleInVisualization,
} from "../../Actions/QuoteAction";
import Notification from "../utilities/Notification/Notification";
import { Severity } from "../utilities/Notification/NotificationContent";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CurrentQuotesAccordian from "./CurrentQuotesAccordian";
import BundleQuotesAccordian from "./BundleQuotesAccordian";
import {
  LocalStorageKeys,
  OpportunityType,
  QuoteStatus,
  UserRole,
} from "../QuoteRequest/Content";
import {
  getCRMDataDetails,
  getQuoteDetailsFromCrm,
} from "../../Actions/CRMAction";
import ViewRecDialog from "./ViewRecDialog";
import moment from "moment";
import Loader from "../utilities/Loader/Loader";
import {
  getArrayOfStringFromCommaSeparatedString,
  getCommaSeparatedStrings,
  isJsonString,
  removeElementFromArray,
} from "../../Helper/Helper";
import ViewNoteDialog from "./ViewNoteDialog";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Congiguration } from "../../Constants/AppConstants";
import { getDecryptedText, getEncryptedText } from "../../Actions/CommonAction";
import QuoteApprovalWorkflowDialog from "./QuoteApprovalWorkflowDialog";
import SearchInput from "../utilities/SearchInput/SearchInput";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@mui/material/Autocomplete";
import CollapsibleRow from "./CollapsibleTableRow";

const CompareQuote = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const dispatch = useDispatch();
  let search = window.location.search;

  let params = new URLSearchParams(search);
  let loggedUser = isJsonString(
    sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER),
  )
    ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER))
    : null;

  const [opportunityId, setOpportunityId] = useState(null);
  const [opportunityType, setOpportunityType] = useState(null);
  const [opportunityIdForLchk, setOpportunityIdForLchk] = useState(null);

  const checkUrlParamsAndLoadPage = () => {
    setLoadingState(true);
    if (search && search !== null && search !== "") {
      const encryptedParams = search.replace("?", "");

      dispatch(getDecryptedText(encryptedParams))
        .then((decryptedParams) => {
          params = new URLSearchParams("?" + decryptedParams);
          const currentOppId = params.get("OpportunityId");
          setOpportunityId(currentOppId);
          setOpportunityIdForLchk(currentOppId);
          sessionStorage.setItem(LocalStorageKeys.OPPORTUNITYID, currentOppId);
          sessionStorage.setItem(
            LocalStorageKeys.CURRENTWORKINGOPPORTUNITY,
            currentOppId,
          );
          getAndSetNewOpportunityDetailsInSession(currentOppId);
        })
        .catch((e) => {
          console.log(e);
          setLoadingState(false);
        });
    } else {
      const opportunityDetailsFromSession = isJsonString(
        sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL),
      )
        ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL))
        : null;
      document.title =
        "Visualize " + opportunityDetailsFromSession?.opportunity;
      setOpportunityId(opportunityDetailsFromSession?.opportunityId ?? "");
      setOpportunityType(opportunityDetailsFromSession?.opportunityType ?? "");
      setOpportunityIdForLchk(
        sessionStorage.getItem(LocalStorageKeys.CURRENTWORKINGOPPORTUNITY) ??
          sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID),
      );
      loadPageData();
    }
  };

  const getAndSetNewOpportunityDetailsInSession = (oppId) => {
    if (oppId) {
      dispatch(getCRMDataDetails(oppId))
        .then((data) => {
          document.title = "Visualize " + data?.opportunity;
          const jsonCRMData = JSON.stringify(data);
          sessionStorage.setItem(LocalStorageKeys.CRMDATAINITIAL, jsonCRMData);
          setOpportunityType(
            OpportunityType.find(
              (x) =>
                x.crmOpportunityType === data.opportunityType ||
                x.crmOpportunityType === data.oppurtunityType,
            ),
          );
          loadPageData();
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  const loadPageData = () => {
    setLoadingState(true);
    getCurrentQuote();
    getQuoteList(false);
    getAllOpportunities(loggedUser?.user?.id);
    getExistingBundlesByUser();
  };

  const [selectedQuotes, setSelectedQuotes] = useState();
  const [allSelectedQuotes, setAllSelectedQuotes] = useState();
  const [quotesToBundle, setQuotesToBundle] = useState([]);
  const [currentQuotes, setCurrentQuotes] = useState();
  const [quoteList, setQuoteList] = useState([]);
  const [allQuoteList, setAllQuoteList] = useState([]);
  const [seachValue, setSearchValue] = useState("");
  const [quotesFromList, setQuotesFromList] = useState([]);
  const [quotesToShowInList, setQuotesToShowInList] = useState(quoteList);
  const [bundleQuotes, setBundleQuotes] = useState([]);
  const [bundledQuotePricingStructure, setBundledQuotePricingStructure] =
    useState("");
  const [bundleCurrency, setBundleCurrency] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [notificationSeverity, setNotificationSeverity] = useState("");
  const [isBundleAdded, setIsBundleAdded] = useState(false);
  const [isCurrentVisible, setIsCurrentVisible] = useState(false);
  const [quoteCount, setQuoteCount] = useState(selectedQuotes?.length);
  const [showDialog, setShowDialog] = useState(false);
  const [dialogData, setDialogData] = useState("");
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogHeading, setDialogHeading] = useState("");
  const [showNotesDialog, setShowNotesDialog] = useState(false);
  const [notesdialogData, setNotesDialogData] = useState("");
  const [notesdialogTitle, setNotesDialogTitle] = useState("");
  const [loadingState, setLoadingState] = useState(false);
  const [quoteListLoading, setQuoteListLoading] = useState(false);
  const [currentQuoteLoadingState, setCurrentQuoteLoadingState] =
    useState(false);
  const [notes, setNotes] = useState([]);
  const [allNotes, setAllNotes] = useState([]);
  const [refreshNotification, setRefreshNotification] = useState(false);
  const [bundleNotification, setBundleNotification] = useState(false);
  const [bundleError, setBundleError] = useState("");
  const [bundleOpportunity, setBundleOpportunity] = useState();
  const [bundleRevenue, setBundleRevenue] = useState([]);
  const [showAprovalConfirmation, setShowAprovalConfirmation] = useState(false);
  const [quoteId, setQuoteId] = useState("");
  const [showAlertNotification, setShowAlertNotification] = useState(false);
  const [alertDialogMessage, setAlertDialogMessage] = useState("");
  const [alertDialogSeverity, setAlertDialogSeverity] = useState("");
  const [expandFirst, setExpandFirst] = useState(true);
  const [bundleButtonDisable, setBundleButtonDisable] = useState(false);
  const [totalData, setTotalData] = useState([]);
  const [callBundle, setCallBundle] = useState(false);
  const [allOpportunities, setAllOpportunities] = useState([]);
  const [dropdownOpportunities, setDropdownOpportunities] = useState([]);
  const [bundleNameByUser, setBundleNameByUser] = useState("");

  const handleCloseDialog = () => {
    setShowDialog(false);
  };
  const handleCloseNotesDialog = () => {
    setShowNotesDialog(false);
  };
  const closeNotificationPopup = () => {
    setShowNotification(false);
  };
  const closeRefreshNotificationPopup = () => {
    setRefreshNotification(false);
  };

  const closeBundleNotificationPopUp = () => {
    setBundleNotification(false);
  };

  const closeShowAlertNotificationPopUp = () => {
    setShowAlertNotification(false);
    setAlertDialogMessage("");
    setAlertDialogSeverity("");
  };
  const showAlert = (severity, message) => {
    setShowAlertNotification(true);
    setAlertDialogMessage(message);
    setAlertDialogSeverity(severity);
  };
  const handleAprovalConfCancel = () => {
    setShowAprovalConfirmation(false);
  };

  useEffect(() => {
    checkUrlParamsAndLoadPage();
  }, []);

  useEffect(() => {
    if (quotesToBundle?.length === 0 && callBundle) {
      getBundlesAfterApprove();
    }
  }, [callBundle, quotesToBundle]);
  const getBundlesAfterApprove = () => {
    setLoadingState(true);
    setBundleOpportunity([]);
    setBundleRevenue([]);
    getExistingBundlesByUser();
    setLoadingState(false);
    setCallBundle(false);
  };

  const getExistingBundlesByUser = () => {
    const sessionOpportunityId =
      sessionStorage.getItem(LocalStorageKeys.CURRENTWORKINGOPPORTUNITY) ??
      sessionStorage.getItem(LocalStorageKeys.OPPORTUNITYID);
    const currentOpportunityId = sessionOpportunityId ?? opportunityId;

    if (
      currentOpportunityId &&
      currentOpportunityId !== null &&
      currentOpportunityId !== ""
    ) {
      const bundleParams = {
        opportunityId: currentOpportunityId,
        userId: loggedUser?.user?.id,
      };
      dispatch(getAllBundlesByUserAndOpportunityId(bundleParams))
        .then((data) => {
          data.map((bundle) => {
            setBundleDetails(bundle);
          });
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  const setBundleDetails = (data) => {
    let rateSum = data?.quotesForBundleDatas.reduce(
      (accumulator, currentValue) =>
        accumulator + currentValue?.rateReqCurrency,
      0,
    );
    let rateSumUsd = data?.quotesForBundleDatas.reduce(
      (accumulator, currentValue) => accumulator + currentValue?.rateUSD,
      0,
    );
    const bundleNameOnly = data?.bundleDetails?.bundleName;
    data?.quotesForBundleDatas.map((quote) => {
      quote.rateReqCurrencySum = rateSum;
      quote.rateUsdSum = rateSumUsd;
      quote.bundleDetails = data?.bundleDetails;
      quote.bundleDetails.bundleNameOnly = bundleNameOnly;
      quote.bundleDetails.bundleName = data?.bundleDetails?.bundleNameByUser
        ? bundleNameOnly + "-" + data?.bundleDetails?.bundleNameByUser
        : bundleNameOnly;      
      quote.totalTcvCad = data?.quotesForBundleRevenueDatas?.[0]?.tcvcad;
    });

    let temp = quotesToBundle;
    let isDuplicate = false;
    
    const bndlRvnue = bundleRevenue;
    bndlRvnue.push(data?.quotesForBundleRevenueDatas?.[0]);
    setBundleRevenue([...bundleRevenue]);

    
    temp.forEach((bundle) => {
        if (
            bundle[0].bundleDetails.bundleId ===
            data?.quotesForBundleDatas[0]?.bundleDetails?.bundleId
        ) {
            isDuplicate = true;
        }
    });
    
    if (!isDuplicate) {
        temp.push(data?.quotesForBundleDatas);
    }

    temp[0]?.forEach((bundle) => {
        bundle.totalTcvCad = bndlRvnue[0]?.tcvcad;
    });
    setQuotesToBundle([...temp]);

    setBundleOpportunity(data?.quotesForBundleOpportunityDatas?.[0] ?? []);


    let ttldta = {
      rateSum: rateSum?.toLocaleString("en", {
        useGrouping: true,
        roundingMode: "trunc",
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }),
      rateSumUsd: rateSumUsd?.toLocaleString("en", {
        useGrouping: true,
        roundingMode: "trunc",
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }),
      priStr: data?.quotesForBundleDatas?.[0]?.pricingStructureName,
      curncy: data?.quotesForBundleDatas?.[0]?.currencyCode,
    };
    let tempTtl = totalData;
    tempTtl?.push(ttldta);
    setTotalData([...tempTtl]);
    setBundleQuotes([]);
    setBundleButtonDisable(false);
  };

  const handleRefresh = () => {
    getQuoteList(true);
  };

  const getQuoteList = (isRefresh) => {
    setQuoteListLoading(true);
    if (isRefresh) {
      setLoadingState(true);
    }

    const selectedOpportunityId =
      opportunityIdForLchk ??
      sessionStorage.getItem(LocalStorageKeys.CURRENTWORKINGOPPORTUNITY);

    selectedOpportunityId?.length > 0
      ? setExpandFirst(true)
      : setExpandFirst(false);
    const requestData = {
      opportunityId: selectedOpportunityId,
      userId: loggedUser?.user?.id,
      companyId: Congiguration?.CompanyId,
    };
    setLoadingState(true);
    dispatch(getAllQuotesByQuoteIdsForVisualization(requestData))
      .then((data) => {
        opportunityType !== "New Business"
          ? setIsCurrentVisible(true)
          : setIsCurrentVisible(false);
        setAllSelectedQuotes(data?.quotesForVisualizations);
        populateQuotes(data?.quotesForVisualizations);
        setAllNotes(data?.quotesForVisualizationNotes);
        setExpandFirst(true);
        if (isRefresh) {
          setRefreshNotification(true);
          setLoadingState(false);
        }
        setQuoteListLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoadingState(false);
        setQuoteListLoading(false);
      });
  };

  const populateQuotes = (quotes) => {
    setSelectedQuotes(pushValuesToArrays(quotes));
    setQuoteList([...quotes]);
    setQuoteCount(quotes?.length);
  };

  useEffect(() => {
    onSubmit(quotesFromList);
  }, [quotesFromList, quoteList]);

  const onSubmit = (list) => {
    const tempList = list?.map((q) => q?.quote);
    let quotes = quoteList?.filter((quote) =>
      tempList?.includes(quote?.quoteName),
    );
  };

  function pushValuesToArrays(quotes) {
    const sample = {
      oppurtunityId: [],
      oppurtunity: [],
      oppurtunityName: [],
      brokerName: [],
      accountName: [],
      quoteId: [],
      quoteName: [],
      accountId: [],
      oppurtunityType: [],
      member: [],
      referrerName: [],
      commission: [],
      percentagePaid: [],
      discount: [],
      currencyId: [],
      currencyName: [],
      currencyCode: [],
      noOfLivesSavedByPartner: [],
      totalPotentialHeadCountOutside: [],
      formalRFPNotes: [],
      competitorsBidders: [],
      pastQuotes: [],
      currentUtilizationWithOtherVendors: [],
      deadline: [],
      noOfRAMs: [],
      locationRAMs: [],
      samPriceRecommendAssumption: [],
      productId: [],
      productName: [],
      productVariationId: [],
      productVariationName: [],
      sessions: [],
      pricingStructureId: [],
      pricingStructureName: [],
      quoteStatusId: [],
      statusName: [],
      accountManagerName: [],
      amHours: [],
      existingPartneredClientInfo: [],
      currentRateEffectiveOn: [],
      pastThreeYrRateHeadCount: [],
      estimatedNoOfAMHrPerYear: [],
      annualUtilizationThreeYrs: [],
      utilization: [],
      hours: [],
      additionalNotes: [],
      companyId: [],
      createdBy: [],
      createdDate: [],
      lastModifiedBy: [],
      lastModifiedDate: [],
      isActive: [],
      id: [],
      seatCount: [],
      totalHeadCount: [],
      blendedRateReqCurrency: [],
      totalAnnualRevenueReqCurrency: [],
      programStartDate: [],
      productAsssumptions: [],
      blank1: [],
      opportunity: [],
      blendedRateUSD: [],
      totalAnnualRevenueUSD: [],
      tcvcad: [],
    };
    quotes?.forEach((quote) => {
      for (let key in sample) {
        if (quote?.hasOwnProperty(key)) {
          if (key === "programStartDate") {
            sample[key].push(moment(quote[key]).format("MM/DD/YYYY"));
          } else if (
            key === "totalAnnualRevenueUSD" ||
            key === "blendedRateUSD"
          ) {
            sample[key].push(
              "USD " +
                (quote[key] !== undefined && quote[key] !== null
                  ? quote[key]?.toLocaleString("en", {
                      useGrouping: true,
                      roundingMode: "trunc",
                      maximumFractionDigits: 2,
                      minimumFractionDigits: 2,
                    })
                  : "0.00"),
            );
          } else if (
            key === "totalAnnualRevenueReqCurrency" ||
            key === "blendedRateReqCurrency"
          ) {
            sample[key].push(
              quote["currencyCode"] +
                " " +
                (quote[key] !== undefined &&
                quote[key] !== null &&
                quote[key] !== 0
                  ? quote[key]?.toLocaleString("en", {
                      useGrouping: true,
                      roundingMode: "trunc",
                      maximumFractionDigits: 2,
                      minimumFractionDigits: 2,
                    })
                  : "0.00"),
            );
          } else {
            sample[key].push(
              quote[key]?.toLocaleString("en", {
                useGrouping: true,
                roundingMode: "trunc",
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              }),
            );
          }
        } else {
          sample[key].push("");
        }
      }
    });
    return sample;
  }

  useEffect(() => {
    if (seachValue === "") {
      setQuotesToShowInList([...quoteList]);
    }
  }, [quoteList, seachValue]);

  const removeFromBundle = (newBundled) => {
    setQuotesToBundle(newBundled);
  };
  const handleBundleClick = () => {
    setBundleButtonDisable(true);
    if (quotesToBundle?.length >= 3) {
      setBundleError(Constants?.BUNDLEERRORMESSAGE);
      setBundleNotification(true);
      setBundleButtonDisable(false);
      return;
    }
    if (bundleQuotes?.length < 2) {
      setBundleError(Constants?.BUNDLESELECTMOREERROR);
      setBundleNotification(true);
      setBundleButtonDisable(false);
      return;
    }
    setIsBundleAdded(true);
    const availableQuotes = allSelectedQuotes ?? quoteList ?? [];
    const selectedQuoteRecords = bundleQuotes
      .map((quoteName) =>
        availableQuotes.find((quote) => quote?.quoteName === quoteName),
      );

    if (selectedQuoteRecords.some((quote) => !quote?.quoteId)) {
      setBundleError(Constants?.MESSAGE_SOMETHINGWENTWRONG);
      setBundleNotification(true);
      setBundleButtonDisable(false);
      return;
    }

    const quoteIds = selectedQuoteRecords.map((quote) => quote.quoteId);

    let quoteToBundle = [];
    const requestData = {
      quoteIds: quoteIds,
      opportunityId: opportunityId,
      bundleNameByUser: bundleNameByUser ? bundleNameByUser : "",
      companyId: Congiguration.CompanyId,
      userId: loggedUser?.user?.id,
    };
    dispatch(getQuotesForBundleInVisualization(requestData))
      .then((data) => {
        let rateSum = data?.quotesForBundleDatas.reduce(
          (accumulator, currentValue) =>
            accumulator + currentValue?.rateReqCurrency,
          0,
        );
        let rateSumUsd = data?.quotesForBundleDatas.reduce(
          (accumulator, currentValue) => accumulator + currentValue?.rateUSD,
          0,
        );
        const bundleNameOnly = data?.bundleDetails?.bundleName;
        data?.quotesForBundleDatas.map((quote) => {
          quote.rateReqCurrencySum = rateSum;
          quote.rateUsdSum = rateSumUsd;
          quote.bundleDetails = data?.bundleDetails;
          quote.bundleDetails.bundleNameOnly = bundleNameOnly;
          quote.bundleDetails.bundleName = data?.bundleDetails?.bundleNameByUser
            ? bundleNameOnly + "-" + data?.bundleDetails?.bundleNameByUser
            : bundleNameOnly;
          quote.totalTcvCad = data?.quotesForBundleRevenueDatas?.[0]?.tcvcad;
        });

        quoteToBundle.push(data?.quotesForBundleDatas);
        let temp = quotesToBundle;
        temp.push(data?.quotesForBundleDatas);
        setQuotesToBundle(temp);
        setBundleOpportunity(data?.quotesForBundleOpportunityDatas?.[0] ?? []);
        const bndlRvnue = bundleRevenue;
        bndlRvnue.push(data?.quotesForBundleRevenueDatas?.[0]);
        setBundleRevenue([...bundleRevenue]);

        let ttldta = {
          rateSum: rateSum?.toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          }),
          rateSumUsd: rateSumUsd?.toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          }),
          priStr: data?.quotesForBundleDatas?.[0]?.pricingStructureName,
          curncy: data?.quotesForBundleDatas?.[0]?.currencyCode,
        };
        let tempTtl = totalData;
        tempTtl?.push(ttldta);
        setTotalData([...tempTtl]);
        setBundleQuotes([]);
        setBundleButtonDisable(false);
        setBundleNameByUser("");
      })
      .catch((e) => {
        setBundleButtonDisable(false);
        console.log(e);
      });
  };

  const handleBundleCheck = (event, item) => {
    const bundledQuotes = bundleQuotes;
    const availableQuotes = allSelectedQuotes ?? quoteList ?? [];
    const quoteToBundle = availableQuotes.find(
      (quote) => quote?.quoteName === item,
    );

    if (!quoteToBundle) {
      setNotificationMessage(Constants?.MESSAGE_SOMETHINGWENTWRONG);
      setNotificationSeverity(Severity.ERROR);
      setShowNotification(true);
      return;
    }

    if (bundledQuotes?.length === 0) {
      setBundledQuotePricingStructure(quoteToBundle?.pricingStructureName);
      setBundleCurrency(quoteToBundle?.currencyCode);
    }

    if (
      bundledQuotes?.length !== 0 &&
      bundledQuotePricingStructure !== quoteToBundle?.pricingStructureName
    ) {
      setNotificationMessage(Constants?.BNDLEQUOTESERRORNOTIFICATION);
      setNotificationSeverity(Severity?.WARNING);
      setShowNotification(true);
      return;
    }
    if (
      bundledQuotes?.length !== 0 &&
      bundleCurrency !== quoteToBundle?.currencyCode
    ) {
      setNotificationMessage(Constants?.BNDLEQUOTESCRNCYERRORNOTIFICATION);
      setNotificationSeverity(Severity?.WARNING);
      setShowNotification(true);
      return;
    }
    if (bundledQuotes?.includes(item)) {
      quotesFromList?.map((q) => {
        if (q?.quote === item) q.checked = false;
        return q;
      });
      bundledQuotes?.splice(bundledQuotes?.indexOf(item), 1);
    } else {
      const updatedQuotes = quotesFromList?.map((q) => {
        if (q?.quote === item) {
          return { ...q, checked: true };
        } else {
          return q;
        }
      });
      setQuotesFromList([...updatedQuotes]);
      bundledQuotes.push(item);
    }
    setBundleQuotes([...bundledQuotes]);
  };

  const isChecked = (quote) => {
    return bundleQuotes?.includes(quote);
  };

  const isEligibleToBundle = (quoteStatusId) => {
    return (
      quoteStatusId == QuoteStatus.QUOTEPENDINGPRICINGTEAM ||
      quoteStatusId == QuoteStatus.QUOTEPENDINGSAMLEADERSHIP ||
      quoteStatusId == QuoteStatus.QUOTEAPPROVED ||
      quoteStatusId == QuoteStatus.QUOTEPENDINGINITIALREQUESTOR ||
      quoteStatusId == QuoteStatus.QUOTEPENDINGPRICINGMANAGER ||
      quoteStatusId == QuoteStatus.QUOTEPENDINGPRICINGMANAGERANDSAMLEADERSHIP ||
      quoteStatusId == QuoteStatus.QUOTEPENDINGPRICINGVPANDSAMLEADERSHIP ||
      quoteStatusId == QuoteStatus.QUOTEPENDINGPRICINGVP 
    );
  };

  const getCurrentQuote = () => {
    setCurrentQuoteLoadingState(true);
    const currentOpportunityId =
      opportunityId ??
      sessionStorage.getItem(LocalStorageKeys.CURRENTWORKINGOPPORTUNITY);
    dispatch(getQuoteDetailsFromCrm(currentOpportunityId))
      .then((data) => {
        setCurrentQuotes(data);
        setCurrentQuoteLoadingState(false);
      })
      .catch((e) => {
        console.log(e);
        setLoadingState(false);
      });
  };

  const viewQuoteClick = (index) => {
    const quoteId = selectedQuotes.quoteId[index];
    sessionStorage.setItem("quoteIdFromVisualize", quoteId);
    window.open(`/viewquote`, "_blank").focus();
  };

  const viewSAMRecClick = (index) => {
    setDialogData(selectedQuotes?.samPriceRecommendAssumption?.[index]);
    setDialogTitle("SAM Recommendation");
    setDialogHeading(selectedQuotes?.quoteName?.[index]);
    setShowDialog(true);
  };
  const approveQuote = (index) => {
    const quoteId = selectedQuotes?.quoteId?.[index];
    setQuoteId(quoteId);
    setShowAprovalConfirmation(true);
  };

  const handelApproveFromBundle = (quoteId) => {
    setQuoteId(quoteId);
    setShowAprovalConfirmation(true);
  };
  const viewNotesClick = (index) => {
    const quoteId = selectedQuotes?.quoteId?.[index];
    const notesObj = allNotes?.filter((note) => note?.quoteId === quoteId);
    setNotes(notesObj);
    setNotesDialogData(notes);
    setNotesDialogTitle("Notes");
    setShowNotesDialog(true);
  };

  const getCellClass = (index, key = "") => {
    if (
      key === "productAsssumptions" ||
      key === "opportunity" ||
      key === "blank1"
    ) {
      return "dragColumn";
    }
    if (index % 2 === 0) return "dragColumn";
    return "dragColumn greyBg";
  };
  const removeBundleRevenue = (index) => {
    const bndlRvnu = bundleRevenue;
    bndlRvnu?.splice(index, 1);
    setBundleRevenue([...bndlRvnu]);
  };
  const showAlerts = (message, severity) => {
    setAlertDialogMessage(message);
    setAlertDialogSeverity(severity);
    setShowAlertNotification(true);
    if (severity === Severity?.SUCCESS) {
      setQuotesToBundle([]);
      getQuoteList(false);
      setCallBundle(true);
    }
  };

  const getAllOpportunities = (userId) => {
    setLoadingState(true);
    dispatch(getOpportunityByUser(userId))
      .then((data) => {
        let oppList = data.map(
          ({ oppurtunityId, oppurtunity, oppurtunityName }) => ({
            oppurtunityId,
            oppurtunity,
            oppurtunityName,
          }),
        );

        setAllOpportunities([...oppList]);
        PopulateOpportunitiesDropdown([...oppList]);
        setLoadingState(false);
      })
      .catch((e) => {
        console.log(e);
        setLoadingState(false);
      });
  };

  const PopulateOpportunitiesDropdown = (opportunityList) => {
    let filteredOpportunities = [];
    let compareOppArray = [];
    if (opportunityList) {
      const compareOppList =
        localStorage.getItem(LocalStorageKeys.COMPAREOPPORTUNITIESLIST) ?? "";
      if (compareOppList && compareOppList !== "") {
        compareOppArray = [
          ...getArrayOfStringFromCommaSeparatedString(compareOppList),
        ];
      }
    }
    filteredOpportunities = [
      ...opportunityList.filter((masterOpp) =>
        compareOppArray.every(
          (filterOpp) => filterOpp !== masterOpp.oppurtunityId,
        ),
      ),
    ];
    setDropdownOpportunities([...filteredOpportunities]);
  };

  const handleOpportunityChange = (event, value) => {
    if (value && value !== null) {
      const paramsForNewTab = `OpportunityId=${value.oppurtunityId}`;
      setLoadingState(true);
      dispatch(getEncryptedText(paramsForNewTab))
        .then((encryptedText) => {
          //adding current and new opp to compare list
          addOpportunityIdToCompareList(value.oppurtunityId);
          addOpportunityIdToCompareList(
            sessionStorage.getItem(LocalStorageKeys.CURRENTWORKINGOPPORTUNITY),
          );
          window.open(`/comparequote?${encryptedText}`, "_blank").focus();
          setLoadingState(false);
        })
        .catch((e) => {
          console.log(e);
          setLoadingState(false);
        });
    }
  };

  const addOpportunityIdToCompareList = (opportunityId) => {
    let existingOpportunityIdsString =
      localStorage.getItem(LocalStorageKeys.COMPAREOPPORTUNITIESLIST) ?? "";
    let existingOpportunityIds = [];

    if (existingOpportunityIdsString && existingOpportunityIdsString !== "") {
      existingOpportunityIds = getArrayOfStringFromCommaSeparatedString(
        existingOpportunityIdsString,
      );
    }
    const index = existingOpportunityIds.indexOf(opportunityId);

    if (index == -1) {
      existingOpportunityIds.push(opportunityId);
    }

    existingOpportunityIdsString = getCommaSeparatedStrings(
      existingOpportunityIds,
    );
    localStorage.setItem(
      LocalStorageKeys.COMPAREOPPORTUNITIESLIST,
      existingOpportunityIdsString,
    );
  };

  const removeOpportunityFromCompareList = (opportunityId) => {
    let existingOpportunityIdsString =
      localStorage.getItem(LocalStorageKeys.COMPAREOPPORTUNITIESLIST) ?? "";
    let existingOpportunityIds = [];
    if (existingOpportunityIdsString && existingOpportunityIdsString !== "") {
      existingOpportunityIds = getArrayOfStringFromCommaSeparatedString(
        existingOpportunityIdsString,
      );
      existingOpportunityIds = [
        ...removeElementFromArray(opportunityId, existingOpportunityIds),
      ];
    } else return;
    existingOpportunityIdsString = getCommaSeparatedStrings(
      existingOpportunityIds,
    );
    localStorage.setItem(
      LocalStorageKeys.COMPAREOPPORTUNITIESLIST,
      existingOpportunityIdsString,
    );
  };

  const handleSearchTextChange = (searchText) => {
    const currentSelectedQuotes = allSelectedQuotes ?? [];
    setSearchValue(searchText ?? "");
    let filteredSelectedQuotes = [...currentSelectedQuotes];
    if (searchText && searchText !== null && searchText !== "") {
      const searchTextTrimmed = searchText.trim();
      filteredSelectedQuotes = currentSelectedQuotes.filter(
        (x) =>
          x.quoteName
            ?.toLowerCase()
            .includes(searchTextTrimmed.toLowerCase()) ||
          x.accountName
            ?.toLowerCase()
            .includes(searchTextTrimmed.toLowerCase()) ||
          x.oppurtunity
            ?.toLowerCase()
            .includes(searchTextTrimmed.toLowerCase()) ||
          x.oppurtunityName
            ?.toLowerCase()
            .includes(searchTextTrimmed.toLowerCase()) ||
          x.createdDate
            ?.toLowerCase()
            .includes(searchTextTrimmed.toLowerCase()) ||
          x.statusName
            ?.toLowerCase()
            .includes(searchTextTrimmed.toLowerCase()) ||
          x.currencyCode
            ?.toLowerCase()
            .includes(searchTextTrimmed.toLowerCase()) ||
          x.totalHeadCount
            ?.toString()
            .toLowerCase()
            .includes(searchTextTrimmed.toLowerCase()) ||
          x.pricingStructureName
            ?.toLowerCase()
            .includes(searchTextTrimmed.toLowerCase()) ||
          x.blendedRateReqCurrency
            ?.toString()
            .toLowerCase()
            .includes(searchTextTrimmed.toLowerCase()) ||
          x.utilization
            ?.toString()
            .toLowerCase()
            .includes(searchTextTrimmed.toLowerCase()) ||
          x.sessions
            ?.toString()
            .toLowerCase()
            .includes(searchTextTrimmed.toLowerCase()) ||
          x.hours
            ?.toString()
            .toLowerCase()
            .includes(searchTextTrimmed.toLowerCase()) ||
          x.totalAnnualRevenueReqCurrency
            ?.toString()
            .toLowerCase()
            .includes(searchTextTrimmed.toLowerCase()) ||
          x.totalAnnualRevenueUSD
            ?.toString()
            .toLowerCase()
            .includes(searchTextTrimmed.toLowerCase()) ||
          x.brokerName
            ?.toLowerCase()
            .includes(searchTextTrimmed.toLowerCase()) ||
          x.commission
            ?.toString()
            .toLowerCase()
            .includes(searchTextTrimmed.toLowerCase()) ||
          x.productName
            ?.toLowerCase()
            .includes(searchTextTrimmed.toLowerCase()) ||
          x.productVariationName
            ?.toLowerCase()
            .includes(searchTextTrimmed.toLowerCase()),
      );
    }
    populateQuotes(filteredSelectedQuotes);
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      sessionStorage.setItem("isClosing", "true");
      setTimeout(() => {
        sessionStorage.removeItem("isClosing");
      }, 100); // Slight delay to ensure the flag is cleared on refresh
      e.preventDefault();
      e.returnValue = "data will get lost";
    };

    const handleUnload = () => {
      if (sessionStorage.getItem("isClosing") === "true") {
        const currentOpportunityId = sessionStorage.getItem(
          LocalStorageKeys.CURRENTWORKINGOPPORTUNITY,
        );
        removeOpportunityFromCompareList(currentOpportunityId);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("unload", handleUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("unload", handleUnload);
    };
  }, []);

  const handleBundleNameChange = (e) => {
    const value = e.target.value ? e.target.value : "";
    setBundleNameByUser(value);
  };
  const [currentOppurtunityHeaders, setCurrentOppurtunityHeaders] =
    useState(oppurtunityHeaders);
  const handleOppurtunityHeaderClick = () => {
    setCurrentOppurtunityHeaders((prevHeaders) =>
      prevHeaders === oppurtunityHeader
        ? oppurtunityHeaders
        : oppurtunityHeader,
    );
  };
  const [currentProductHeaders, setCurrentProductHeaders] =
    useState(ProductHeader);
  const handleProductHeaderClick = () => {
    setCurrentProductHeaders((prevHeaders) =>
      prevHeaders === ProductHeader ? ProductHeaders : ProductHeader,
    );
  };
  const [currentTotalHeaders, setCurrenttotalHeaders] = useState(totalHeader);
  const handleTotalHeaderClick = () => {
    setCurrenttotalHeaders((prevHeaders) =>
      prevHeaders === totalHeader ? totalHeaders : totalHeader,
    );
  };
  return (
    <HomePageWrapper>
      <Banner
        Heading={Constants.BANNER_HEADING}
        Paragraph={Constants.BANNER_PARAGRAPH}
        showBreadcrumb={true}
        breadcrumbName={Constants.BREADCRUMB_NAME}
      />

      <DropdownWrap>
        <CurrentQuotesAccordian
          currentQuote={currentQuotes}
          headers={currentQuoteKeys}
          isCurrentVisible={isCurrentVisible}
          isLoading={currentQuoteLoadingState}
        />

        <BundleQuotesAccordian
          quotesToBundle={quotesToBundle}
          quoteHeaders={quoteHeaders}
          removeFromBundle={removeFromBundle}
          bundleOpportunity={bundleOpportunity}
          bundleRevenue={bundleRevenue}
          removeBundleRevenue={removeBundleRevenue}
          handelApproveFromBundle={handelApproveFromBundle}
          showNotification={showAlert}
        />
        <TableBox>
          <Accordion defaultExpanded={expandFirst} className="tableAccordion">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
              aria-controls="panel1-content"
              id="panel1-header"
              className="quotedHeadingBox"
            >
              <div className="noBundleText">
                {Constants?.QUOTES}
                <Tooltip
                  title={<span className="tooltip">{QuotedToolTip}</span>}
                >
                  <InfoOutlinedIcon />
                </Tooltip>
              </div>
              <div className="searchOpportunityContainer">
                <div className="searchTextBox">
                  <SearchInput
                    placeholder="Search Quote"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onSearchChange={handleSearchTextChange}
                  />
                </div>

                <div
                  className="opportunityDropdown"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <FormControl
                    className="customDropdown"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <Autocomplete
                      size="small"
                      options={dropdownOpportunities}
                      getOptionLabel={(option) => option.oppurtunity}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      onChange={handleOpportunityChange}
                      renderInput={(params) => (
                        <TextField
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          placeholder="Select or Search Opportunity"
                          size="small"
                          {...params}
                          variant="outlined"
                        />
                      )}
                    />
                  </FormControl>
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              {selectedQuotes?.quoteName?.length > 0 ? (
                <>
                  <Box className="buttonContainer">
                    <div className="infoContainer">
                      <InfoOutlinedIcon className="infoIcon" />
                      <Typography className="infotext">
                        <strong>{Constants?.TOCRTBNDL}</strong>
                        {Constants?.PLSSLMORE}
                        <strong>{Constants?.ONEQT}</strong>
                        {Constants?.BUNDLEINFOTEXT}
                      </Typography>
                    </div>
                    <Button
                      variant="outlined"
                      className="refreshButton"
                      onClick={handleRefresh}
                    >
                      <RefreshIcon /> {Constants?.REFRESH}
                    </Button>
                    <TextField
                      placeholder="Enter Bundle Name"
                      onChange={handleBundleNameChange}
                      value={bundleNameByUser}
                      size="small"
                    />

                    <Button
                      variant="contained"
                      className="bundleButton"
                      onClick={handleBundleClick}
                      disabled={bundleButtonDisable}
                    >
                      {bundleButtonDisable ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : (
                        Constants?.BUNDLE
                      )}
                    </Button>
                  </Box>
                  <CompareQuotesTableWrap component={Paper}>
                    <Box className="tableContainer">
                      <Table aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell
                              sx={{
                                background: "#bdd0e9",
                              }}
                              className="fixedHeader"
                            >
                              {Constants?.ACTION}
                            </TableCell>

                            {selectedQuotes?.quoteName?.map((data, index) =>
                              isEligibleToBundle(
                                selectedQuotes.quoteStatusId[index],
                              ) ? (
                                <TableCell
                                  key={index}
                                  className={"dragColumnHeader"}
                                >
                                  <div className="closeIcon">
                                    <FormControlLabel
                                      sx={{ mr: 0 }}
                                      control={
                                        <Checkbox
                                          className="qtcheckbox"
                                          icon={
                                            <CheckBoxOutlineBlankIcon className="checkboxIcon" />
                                          }
                                          checkedIcon={<CheckBoxIcon />}
                                          checked={isChecked(data)}
                                          onChange={(e) =>
                                            handleBundleCheck(e, data)
                                          }
                                        />
                                      }
                                    />
                                    {data}
                                  </div>
                                </TableCell>
                              ) : (
                                <TableCell
                                  key={index}
                                  className={"dragColumnHeader"}
                                >
                                  <div className="closeIcon">{data}</div>
                                </TableCell>
                              ),
                            )}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow className={"tabrowWhite"}>
                            <TableCell
                              size="small"
                              className={"fixedColumnoneWhite"}
                            >
                              {actionHeaders?.viewQuote}
                            </TableCell>
                            {quoteList?.map((_, index) => (
                              <TableCell
                                key={index}
                                className={getCellClass(index)}
                              >
                                <Link
                                  onClick={() => viewQuoteClick(index)}
                                  className="viewLink"
                                >
                                  <RemoveRedEyeOutlinedIcon />
                                  {Constants?.VIEW}
                                </Link>
                              </TableCell>
                            ))}
                          </TableRow>
                          <TableRow className={"tabrowWhite"}>
                            <TableCell
                              size="small"
                              className={"fixedColumnoneWhite"}
                            >
                              {actionHeaders?.approve}
                            </TableCell>
                            {quoteList?.map((_, index) => (
                              <TableCell
                                key={index}
                                className={getCellClass(index)}
                              >
                                {(quoteList?.[index]?.quoteStatusId ===
                                  QuoteStatus?.QUOTEPENDINGPRICINGTEAM &&
                                  loggedUser?.userRole[0]?.id ===
                                    UserRole?.PRICINGTEAM) ||
                                (quoteList?.[index]?.quoteStatusId ===
                                  QuoteStatus?.QUOTEPENDINGSAMLEADERSHIP &&
                                  loggedUser?.userRole?.[0]?.id ===
                                    UserRole?.SAMLEADERSHIPTEAM) ? (
                                  <Link
                                    onClick={() => approveQuote(index)}
                                    className="viewLink approveLink"
                                  >
                                    <CheckOutlinedIcon />
                                    {Constants.CONFIRM}
                                  </Link>
                                ) : (
                                  <span className="inactiveLink">
                                    <CheckOutlinedIcon /> {Constants.CONFIRM}
                                  </span>
                                )}
                              </TableCell>
                            ))}
                          </TableRow>
                          <TableRow className={"tabrowWhite "}>
                            <TableCell
                              size="small"
                              className={"fixedColumnoneWhite "}
                            >
                              {actionHeaders?.SAMRecomm}
                            </TableCell>
                            {quoteList?.map((_, index) => (
                              <TableCell
                                key={index}
                                className={getCellClass(index)}
                              >
                                <Link
                                  onClick={() => viewSAMRecClick(index)}
                                  className="viewLink"
                                >
                                  <RemoveRedEyeOutlinedIcon />
                                  {Constants.VIEW}
                                </Link>
                              </TableCell>
                            ))}
                          </TableRow>
                          <TableRow className={"tabrowWhite"}>
                            <TableCell
                              size="small"
                              className={"fixedColumnoneWhite"}
                            >
                              {actionHeaders?.notes}
                            </TableCell>
                            {quoteList?.map((_, index) => (
                              <TableCell
                                key={index}
                                className={getCellClass(index)}
                              >
                                <Link
                                  onClick={() => viewNotesClick(index)}
                                  className="viewLink"
                                >
                                  <RemoveRedEyeOutlinedIcon />
                                  {Constants.VIEW}
                                </Link>
                              </TableCell>
                            ))}
                          </TableRow>
                          {Object?.keys(headers)?.map((key) => (
                            <CollapsibleRow
                              headers={currentOppurtunityHeaders}
                              keyValue={key}
                              selectedQuotes={selectedQuotes}
                              getCellClass={getCellClass}
                              statusColors={statusColors}
                              headername="opportunity"
                              handleClick={handleOppurtunityHeaderClick}
                              direction={"asc"}
                            />
                          ))}
                          {Object?.keys(headers)?.map((key) => (
                            <CollapsibleRow
                              headers={currentTotalHeaders}
                              keyValue={key}
                              selectedQuotes={selectedQuotes}
                              getCellClass={getCellClass}
                              statusColors={statusColors}
                              headername="blank1"
                              handleClick={handleTotalHeaderClick}
                              direction={"desc"}
                            />
                          ))}
                          {Object?.keys(headers)?.map((key) => (
                            <CollapsibleRow
                              headers={currentProductHeaders}
                              keyValue={key}
                              selectedQuotes={selectedQuotes}
                              getCellClass={getCellClass}
                              statusColors={statusColors}
                              headername="productAsssumptions"
                              handleClick={handleProductHeaderClick}
                              direction={"desc"}
                            />
                          ))}
                        </TableBody>
                      </Table>
                    </Box>
                  </CompareQuotesTableWrap>
                </>
              ) : (
                <Box className="currentNoData">
                  {Constants.QUOTEDNODATATEXT}
                </Box>
              )}
            </AccordionDetails>
          </Accordion>
        </TableBox>
      </DropdownWrap>

      {showNotification && (
        <Notification
          open={showNotification}
          onClose={closeNotificationPopup}
          message={notificationMessage}
          severity={notificationSeverity}
        />
      )}
      {refreshNotification && (
        <Notification
          open={refreshNotification}
          onClose={closeRefreshNotificationPopup}
          message={Constants.REFRESHMESSAGE}
          severity={Severity.SUCCESS}
        />
      )}
      {bundleNotification && (
        <Notification
          open={bundleNotification}
          onClose={closeBundleNotificationPopUp}
          message={bundleError}
          severity={Severity.ERROR}
        />
      )}
      {showAlertNotification && (
        <Notification
          open={showAlertNotification}
          onClose={closeShowAlertNotificationPopUp}
          message={alertDialogMessage}
          severity={alertDialogSeverity}
        />
      )}
      {showDialog && (
        <ViewRecDialog
          data={dialogData}
          handleClose={handleCloseDialog}
          quoteName={dialogHeading}
          title={dialogTitle}
          show={showDialog}
        />
      )}
      {showNotesDialog && (
        <ViewNoteDialog
          notes={notes}
          handleClose={handleCloseNotesDialog}
          title={notesdialogTitle}
          show={showNotesDialog}
        />
      )}
      {showAprovalConfirmation && (
        <QuoteApprovalWorkflowDialog
          isConfirmation={showAprovalConfirmation}
          show={showAprovalConfirmation}
          dialogText={"Approval"}
          title={"Approve"}
          quoteId={quoteId}
          handleCancelClick={handleAprovalConfCancel}
          showAlerts={showAlerts}
          handleClose={handleAprovalConfCancel}
        />
      )}

      <Loader open={loadingState || quoteListLoading} />
      <Loader open={callBundle} />
    </HomePageWrapper>
  );
};

export default CompareQuote;
